import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import zh from './locales/zh.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import nl from './locales/nl.json';
import es from './locales/es.json';
import { getUserLocale, setUserLocale } from './utils/localeUtils';

// 从localeUtils获取语言设置，去掉区域码
const getLanguageCode = () => {
  const fullLocale = getUserLocale();
  return fullLocale.split('-')[0] || 'en'; // 只取语言代码部分，如'zh-CN'取'zh'
};

const messages = {
  en,
  zh,
  fr,
  de,
  nl,
  es
};

// Create i18n instance
const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: getLanguageCode(), // Use the same function that reads from plant_care_locale
  fallbackLocale: 'en', // Fallback locale
  messages,
  // Disable v-t directive
  directive: {
    vt: false
  }
});

// Export a function to change the locale
export function setLocale(locale) {
  i18n.global.locale.value = locale;
  localStorage.setItem('language', locale);
  
  // 根据选择的语言设置合适的full locale
  let fullLocale;
  switch(locale) {
    case 'zh': fullLocale = 'zh-CN'; break;
    case 'fr': fullLocale = 'fr-FR'; break;
    case 'de': fullLocale = 'de-DE'; break;
    case 'nl': fullLocale = 'nl-NL'; break;
    case 'es': fullLocale = 'es-ES'; break;
    default: fullLocale = 'en-US';
  }
  
  setUserLocale(fullLocale);
  document.querySelector('html').setAttribute('lang', locale);
}

// Export the i18n instance
export default i18n; 